import React from 'react'

export interface IProps {
  id?: string
  buttonClass: string
  iconClass?: string
  label: string
  onClick: () => void
  onTrackClick?: () => void
}

export default (props: IProps) => {
  const handleClick = () => {
    props.onClick()
    if (props.onTrackClick) {
      props.onTrackClick()
    }
  }

  return (
    <a id={props.id} className={props.buttonClass} onClick={handleClick}>
      {props.iconClass && <i className={props.iconClass}></i>}
      {props.label}
    </a>
  )
}
